import React, {useState, useEffect, useRef, useCallback} from 'react';

import Table from './table'
import PageTitle from "./page-title"
import Dialog from './dialogs'
import RenderFormFields from './forms'
import { createPortal } from 'react-dom';

import { socket, requestData } from './../../socket';
import AppContext from "./../../app-context"

import {decode} from 'html-entities';
import ChatsViews from "../tables/old/chatsViews";
import PopUpDialog from "./popup-dialog";
import {useAuth} from "../../AuthContext";

import { useNavigate } from 'react-router-dom';

const getInitialLang = () => (localStorage.getItem('lang') || 'en').toLowerCase();
const successDict = {
    en: { deletedTitle: "You have successfully deleted your item", deletedBody: "You can now return to the dashboard.", close: "Close", deletedConfirm: "Confirm" },
    ru: { deletedTitle: "Элемент успешно удалён", deletedBody: "Теперь вы можете вернуться к панели.", close: "Закрыть", deletedConfirm: "Подтвердить" },
    ua: { deletedTitle: "Елемент успішно видалено", deletedBody: "Тепер ви можете повернутися до панелі.", close: "Закрити", deletedConfirm: "Підтвердити" },
};

const AddContactButton = ({ addFunction, addTitle, disable, style={}, wrapperStyle={} }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipTimeout = useRef(null);
    const isDisabled = disable?.add?.disable;
    const tooltipText = disable?.add?.title;

    // Handle tooltip show with delay
    const handleMouseEnter = () => {
        if (isDisabled) {
            tooltipTimeout.current = setTimeout(() => setShowTooltip(true), 500); // Show after 500ms
        }
    };

    // Handle tooltip hide with delay
    const handleMouseLeave = () => {
        clearTimeout(tooltipTimeout.current);
        tooltipTimeout.current = setTimeout(() => setShowTooltip(false), 300); // Hide after 300ms
    };

    return (
        <div
            className="relative inline-block"
            style={{
                height: wrapperStyle.height || "auto",
                zIndex: isDisabled ? "100000" : "0",
                display: wrapperStyle.display || "flex",
                alignItems: wrapperStyle.alignItems || "flex-end",
                width: wrapperStyle.width || "auto",
                paddingTop: wrapperStyle.paddingTop || 0,
                paddingBottom: wrapperStyle.paddingBottom ?? 0,
                marginTop: wrapperStyle.marginTop || 0,
                marginBottom: wrapperStyle.marginBottom || 0,
                ...wrapperStyle,
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <button
                id="btn-add-contact"
                style={{
                    ...style,
                    cursor: isDisabled ? "help" : "pointer",
                    marginBottom: typeof style.marginBottom === "undefined" ? 32 : style.marginBottom,
                }}
                className={`btn btn-primary d-flex align-items-center px-4 py-2 rounded-md ${
                    isDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
                }`}
                onClick={!isDisabled ? addFunction : undefined}
                disabled={isDisabled}
            >
                <i className="ti ti-users text-white me-1 fs-5"></i> {addTitle}
            </button>

            {isDisabled && (
                <div
                    style={{
                        textAlign: "left",
                        position: "absolute",
                        left: "50%",
                        top: "100%",
                        transform: "translateX(-50%)",
                        minWidth: "220px",
                        maxWidth: "260px",
                        pointerEvents: "none",
                    }}
                    className={`p-3 text-sm text-white bg-dark rounded shadow-lg transition-opacity duration-200 ${
                        showTooltip ? "opacity-100 visible" : "opacity-0 invisible"
                    }`}
                >
                    {tooltipText}
                </div>
            )}
        </div>
    );
};

const BasicCRUD = (props) => {
    const { user } = useAuth();
    const lang = getInitialLang();
    const tCommon = successDict[lang] || successDict.en;

    const object = props.object
    const fn = props.fn || "list"
    const args = props.args || {}

    const [data, setData] = useState([]);
    const [fieldsFormData, setFieldsFormData] = useState([]);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [deleteDialogData, setDeleteDialogData] = useState({});

    const [singleArg, setSingleArg] = useState(false);

    const columns = props.columns || []

    const singleArgs = props?.singleArgs ?? false;

    const navigate = useNavigate();

    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smooth scrolling
        });
    };

    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        if (!user?.token) {
            return undefined;
        }
        if(props.ownHandler && singleArgs == false){
            socket.on(`${object}:${fn}-data`, (data) => {
                setData(data)
            });


            requestData(user, object, args, fn);
        }

        const genData = (data) => {
            let newData = {}

            if (data['id']) newData['id'] = data['id']

            let fields = (fieldsFormData[actionName] || fieldsFormData['default']) || []

            for(var x=0;x<fields.length;x++){
                //console.log(" num ------------------ ", x, fields[x].fields)
                for(var z=0;z<fields[x].fields.length;z++){
                    for(var i=0;i<fields[x].fields[z].length;i++) {
                        const item = fields[x].fields[z][i]
                        const key = item.key

                        if (data[key]){

                            if (item.type == "tinymce" || item.type == "draftjs" || item.type == "textarea"){
                                newData[key] = decode(data[key])
                                newData[`init_${key}`] = decode(data[key])
                            }else{
                                newData[key] = data[key]
                            }
                        }
                    }
                }
            }

            return newData
        }
        if(!singleArgs || (singleArgs && singleArgs.create)){
            socket.on(`${object}:create-response`, (data) => {
                if (data.status == 1){
                    if((props.noCreateDialog || false) == false) {
                        data['created'] = 1
                        setResponse(data)

                        AppContext.pages[object].pageNum = data.page
                        setPageNum(data.page)
                        setResponse(data)

                        closeCreateUserDialog()
                    }
                    reloadList(data.page)
                }

                setResponse(data)

                singleArgs?.setRefresh(singleArgs?.refresh ? 0 : 1)
                scrollTop()

                //console.log(`${object}:create-response`, data)
            })
            socket.on(`${object}:create-data`, (data) => {
                if (data.status == 1){
                    if((props.noCreateDialog || false) == true) {
                        let newData = genData(data.data[0])

                        setFieldsData({...newData})

                        showDialog(true);
                    }
                }
            })
        }

        if(!singleArgs || (singleArgs && singleArgs.edit)) {
            socket.on(`${object}:update-response`, (data) => {

                data['updated'] = 1
                setResponse(data)

                if (data.status == 1) {
                    closeCreateUserDialog()
                    reloadList(data.page)
                }

                console.log(`${object}:update-response`, data)
                if (singleArgs && typeof singleArgs.setRefresh === "function") {
                    singleArgs.setRefresh(singleArgs.refresh ? 0 : 1)
                }

                scrollTop()
            })
        }
        if(!singleArgs || (singleArgs && singleArgs.delete)) {
            socket.on(`${object}:delete-response`, (data) => {
                data['delete'] = 1


                console.log(`${object}:delete-response`, data)

                AppContext.pages[object].pageNum = data.page
                setPageNum(data.page)
                setResponse(data)

                console.log(`${object}:delete-response`, data)
                if (singleArgs && typeof singleArgs.setRefresh === "function") {
                    singleArgs.setRefresh(singleArgs.refresh ? 0 : 1)
                }
                singleArgs?.setRefresh(singleArgs?.refresh ? 0 : 1)

                setShowMessage(true)

                if (data.status == 1) {
                    setShowDeleteDialog(false);
                    setSelectedItems({});
                    reloadList(data.page);
                }

                scrollTop()
            })
        }
        //fields = props.fields || []

        const isObject = (value) => {
            return value !== null && typeof value === 'object' && !Array.isArray(value);
        };

        let fields = []
        if(isObject(props.fields)){
            fields = props.fields
        }else{
            fields = {default: [...props.fields || []]}
        }
        setFieldsFormData(fields)

        //console.log("<fields ----->", object, props.fields, fields)


        if(singleArgs?.delete == 1){
            //setSingleArg(true)
            crudTableAction("delete", singleArgs.details)
        }

        if(singleArgs?.edit == 1){
            //setSingleArg(true)
            //console.log("edit-crud", singleArgs.details)
            crudTableAction("edit", singleArgs.details)
        }

        console.log("fields ::: ",JSON.stringify(props.fields), singleArgs)

        return () => {
            if(props.ownHandler) {
                socket.off(`${object}:${fn}-data`)
            }

            if(!singleArgs || (singleArgs && singleArgs.create)) {
                socket.off(`${object}:create-response`);
                socket.off(`${object}:create-data`);
            }

            if(!singleArgs || (singleArgs && singleArgs.edit)) {
                socket.off(`${object}:update-response`);
            }

            if(!singleArgs || (singleArgs && singleArgs.delete)) {
                socket.off(`${object}:delete-response`);
            }
        };
    }, [props.args, JSON.stringify(props.fields), props.fieldsVersion, singleArgs, user?.token]);


    const handleConfirmDelete = () => {
        const deleteData = {
            token: user.token,
            page: AppContext.pages[object]?.pageNum || 1,
            items_count: AppContext.rows_per_page,
            fields: deleteDialogData.data,
            ...props.args || {},
        };

        socket.emit(`${object}:delete`, deleteData);
        setShowDeleteDialog(false);
    };

    const handleCancelDelete = () => {
        setShowDeleteDialog(false);
    };

    const [actionName, setActionName] = useState("");
    const [dialog, showDialog] = useState(false);

    const response = props.response
    const setResponse = props.setResponse
    const fieldsData = props.fieldsData
    const setFieldsData = props.setFieldsData
    const [pendingFieldsData, setPendingFieldsData] = useState({})

    function fieldsChange(event, key, item_id=null){
        var data = {}//...fieldsData}
        if(item_id == null) {
           data = {[key]: event.target.value}
        }else{
            data = {[key]: fieldsData[key] || []}
            //console.log("push ::: ", data, key)
            //if (!data[key]) data[key] = []
            if(data[key].includes(item_id)){
                data[key] = data[key].filter(e => e !== item_id)
            }else{
                data[key].push(item_id)
            }

        }

        setFieldsData((prevState) => ({
            ...prevState,
            [key]: data[key],
        }))
    }

    const [pageNum, setPageNum] = useState(AppContext.pages && AppContext.pages[object] && AppContext.pages[object].pageNum || 1)

    function handleAddButton() {
        console.log("handle add button :: ", props.noCreateDialog);

        if((props.noCreateDialog || false) == false) {
            setResponse([]);
            setFieldsData({});
            setActionName("add")
            showDialog(true);
        }else{
            var data = {
                token: user.token,
                page: AppContext.pages[object].pageNum,
                items_count: AppContext.rows_per_page,
                fields: {...props.args || {}},
                ...searchData,
                ...props.args || {},
            };

            socket.emit(`${object}:create`, data);
        }
    }

    const addButtonHandler = props.customAddFunction || handleAddButton;

    function closeCreateUserDialog() {
        showDialog(false);
        setPendingFieldsData({});
    }

    const externalAddHandledRef = useRef(null);
    useEffect(() => {
        if (props.externalAddTrigger === null || typeof props.externalAddTrigger === "undefined") return;
        if (externalAddHandledRef.current === props.externalAddTrigger) return;
        externalAddHandledRef.current = props.externalAddTrigger;
        handleAddButton();
        props.onExternalAddHandled && props.onExternalAddHandled();
    }, [props.externalAddTrigger, props.onExternalAddHandled]);

    const [searchData, setSearchData] = useState(() => {
        const simple_search = localStorage.getItem(`${object}_search`) || {};
        return simple_search
    })

    function saveCreateUserDialog() {
        var tmpFieldsData = Object.keys(fieldsData || {}).length ? fieldsData : pendingFieldsData

        let fields = (fieldsFormData[actionName] || fieldsFormData['default']) || []
        for(var i=0;i<fields.length;i++){
            tmpFieldsData[fields[i].key] = tmpFieldsData[fields[i].key] || fields[i].default_value
        }

        if(props.executeBeforeSave){
            tmpFieldsData = props.executeBeforeSave(tmpFieldsData)
        }

        console.log("Fields Data: ", tmpFieldsData)

        var data = {
            token: user.token,
            page: AppContext.pages[object].pageNum,
            items_count: AppContext.rows_per_page,
            fields: {...props.args || {}, ...tmpFieldsData},
            ...searchData,
            ...props.args || {},
            //simple_search_text: searchData
        };

        if (data.fields.id > 0){
            socket.emit(`${object}:update`, data);
        }else{
            socket.emit(`${object}:create`, data);
        }
    }

    const [selectedItems, setSelectedItems] = useState({})

    const crudTableAction = (action, data) => {
        console.log("crud table actions", action, data)

        if (action == "edit"){

            /*setResponse([]);*/

            const actionKey = "edit";
            let newData = {}
            if (data['id']) newData['id'] = data['id']

            let fields = (fieldsFormData[actionKey] || fieldsFormData['default']) || []
            for(var x=0;x<fields.length;x++){
                console.log(" num ------------------ ", x, fields[x].fields)
                for(var z=0;z<fields[x].fields.length;z++){
                    for(var i=0;i<fields[x].fields[z].length;i++) {
                        const item = fields[x].fields[z][i]
                        const key = item.key

                        if (data[key] !== undefined && data[key] !== null) {
                            if (item.type == "tinymce" || item.type == "draftjs" || item.type == "textarea"){
                                newData[key] = decode(data[key])
                                newData[`init_${key}`] = decode(data[key])
                            }else{
                                newData[key] = data[key]
                            }
                        }
                    }
                }
            }


            if(props.executeBeforeEdit){
                newData = props.executeBeforeEdit(newData)
            }

            /*setFieldsData({...newData})*/
            setPendingFieldsData(newData);

            setFieldsData(prevData => {
                const prevJson = JSON.stringify(prevData);
                const newJson = JSON.stringify(newData);

                if (prevJson === newJson) {
                    console.log('No change detected');
                    return prevData; // No state change
                }

                console.log('Data has changed');
                return { ...newData }; // Update state
            });

            setActionName(actionKey)
            showDialog(true);
        }

        if (action == "delete"){
            if (props.deleteConfirmationDialog) {
                const { alert, title, text, column } = props.deleteConfirmationDialog;

                const columnValue = data[column];
                if (!columnValue) {
                    console.error(`Column "${column}" not found in data`);
                    return;
                }

                setDeleteDialogData({
                    alert: alert,
                    title: title.replace('{name}', columnValue),
                    text: text.replace('{name}', columnValue),
                    data, // Данные для удаления
                    columnValue, // Проверочное значение
                    userInput: '', // Поле для ввода
                });
                setShowDeleteDialog(true);
            }else{
                var data = {
                    token: user.token,
                    page: AppContext.pages[object].pageNum,
                    items_count: AppContext.rows_per_page,
                    fields: data,
                    ...props.args || {},
                };

                if (window.confirm('Are you sure you wish to delete this item?')){
                    socket.emit(`${object}:delete`, data);
                }
            }
        }

        if (action == "multiDelete"){


            var data = {
                token: user.token,
                page: AppContext.pages[object].pageNum,
                items_count: AppContext.rows_per_page,
                fields: {},
                ...props.args || {},
            };

            data.fields = {...props.data.data[0], id: []}

            let choosedItems = 0
            props.data.data.forEach((item, index) => {
                if(selectedItems[`item_${item.id}`]){
                    data.fields.id.push(item.id)
                    choosedItems++
                }
            })

            if (choosedItems > 0){
                if (window.confirm('Are you sure you wish to delete selected items?')){
                    socket.emit(`${object}:delete_All`, data);
                }
            }else{
                window.alert('Please, choose items!')
            }

            console.log("debug", data, selectedItems, props.data.data)

        }

        if (props.tableAction){
            props.tableAction(action, data)
        }


    }

    const reloadList = useCallback((pageOverride = null) => {
        if (!props.ownHandler || !user?.token) return;
        const targetPage = pageOverride ?? (AppContext.pages[object]?.pageNum || 1);
        requestData(user, object, { ...(props.args || {}), page: targetPage }, fn);
    }, [props.ownHandler, user, object, props.args, fn]);

    const tableAction = crudTableAction

    const actions = props.actions
    const multiActions = props.multiActions

    const hideTitle = props.hideTitle || false

    let tableData = props.data || []
    if(props.ownHandler){
        tableData = data
    }


    //console.log(":: table data :: ", tableData, fields)

    //console.log("single args", singleArgs,)
    //console.log(fieldsFormData, actionName, fieldsData ?? [], fieldsChange, response, saveCreateUserDialog)

    console.log("use_cpu_notifies::::", fieldsData["use_cpu_notifies"], fieldsData)

    return (
        <>
            {!singleArgs &&
            <>
                {showDeleteDialog && (
                    <Dialog
                        title={deleteDialogData.title}
                        hideActions
                        closeDialog={handleCancelDelete}
                        footerContent={
                            <div className="d-flex w-100 justify-content-end gap-2">
                                <button
                                    type="button"
                                    className="btn bg-danger-subtle text-danger"
                                    onClick={handleCancelDelete}
                                >
                                    {tCommon.close}
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${
                                        deleteDialogData.userInput === deleteDialogData.columnValue
                                            ? "btn-primary text-white"
                                            : "btn-secondary text-white"
                                    }`}
                                    onClick={handleConfirmDelete}
                                    disabled={deleteDialogData.userInput !== deleteDialogData.columnValue}
                                    style={{
                                        cursor:
                                            deleteDialogData.userInput === deleteDialogData.columnValue
                                                ? "pointer"
                                                : "not-allowed",
                                    }}
                                >
                                    {tCommon.deletedConfirm || "Confirm"}
                                </button>
                            </div>
                        }
                    >
                        <div className="p-4">
                            <div
                                className="mb-4 p-3"
                                style={{
                                    border: "1px solid #f5c2c7",
                                    backgroundColor: "#f8d7da",
                                    borderRadius: "8px",
                                    color: "#842029",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "1.5rem",
                                        marginRight: "10px",
                                    }}
                                >
                                    ❗
                                </span>
                                <span>{deleteDialogData.alert}</span>
                            </div>

                            <div
                                className="p-3"
                                style={{
                                    border: "1px solid #d1d1d1",
                                    borderRadius: "8px",
                                    backgroundColor: "#f8f9fa",
                                }}
                            >
                                <h4 style={{ marginBottom: "10px", color: "#495057" }}>
                                    {deleteDialogData.title}
                                </h4>
                                <p
                                    style={{
                                        marginBottom: "10px",
                                        color: "#6c757d",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {deleteDialogData.text}
                                </p>
                                <input
                                    type="text"
                                    placeholder={`Enter "${deleteDialogData.columnValue}" to confirm`}
                                    value={deleteDialogData.userInput}
                                    onChange={(e) =>
                                        setDeleteDialogData((prev) => ({
                                            ...prev,
                                            userInput: e.target.value,
                                        }))
                                    }
                                    className="form-control"
                                    style={{
                                        border: "1px solid #ced4da",
                                        borderRadius: "5px",
                                        padding: "10px",
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </div>
                    </Dialog>
                )}


                {dialog ? (
                    <Dialog title={props.addTitle}
                            editTitle={props.editTitle}
                            fieldsData={fieldsData}
                            closeDialog={closeCreateUserDialog}
                            saveDialog={saveCreateUserDialog} >

                        <div className="flex gap-10 flex-column">
                            <div className="form-group col-md-12">
                                {response?.status === 0 && (response?.err?.general || response?.err?.message) ? (
                                    <div className="alert alert-danger mb-3">
                                        {response?.err?.general || response?.err?.message}
                                    </div>
                                ) : null}
                                <RenderFormFields
                                    fields={fieldsFormData}
                                    actionName={actionName}
                                    fieldsData={Object.keys(fieldsData || {}).length ? fieldsData : pendingFieldsData}
                                    fieldsChange={fieldsChange}
                                    response={response}
                                    saveAction={saveCreateUserDialog}
                                />
                            </div>

                        </div>
                    </Dialog>
                ) : null}


                {!hideTitle && <PageTitle title={props.title} subTitle={props.subTitle || props.title} homeUrl={props.homeURL} />}

                {props.children}

                <div>
                    <Table object={object}
                           args={props.args || {}}
                           filters={props.filters || {}}
                           pageNum={pageNum}
                           setPageNum={setPageNum}
                           setResponse={setResponse}
                           searchData={searchData}
                           setSearchData={setSearchData}
                           addTitle={props.addTitle}
                           disable={props.disable || {}}
                           addFunction={addButtonHandler}
                           addButtonWrapperClass={props.addButtonWrapperClass}
                           addButtonWrapperStyle={props.addButtonWrapperStyle}
                           columns={columns} data={tableData}
                           selectedItems={selectedItems} setSelectedItems={setSelectedItems}
                           hideActions={props.hideActions || false}
                           disableSaveFilters={props.disableSaveFilters || false}
                           actions={actions} tableAction={tableAction}
                           hideGroupActions={props.hideGroupActions || false} multiActions={multiActions}
                           searchFields={props.searchFields || null}
                           viewModes={props.viewModes}
                           defaultViewMode={props.defaultViewMode}
                           renderItem={props.renderItem}
                           cardLayout={props.cardLayout}
                    />
                </div>
            </>}
            {singleArgs && singleArgs.delete && <>
                {showMessage && (
                    (() => {
                        const redirectTo = props.afterDeleteRedirect || props.homeURL || "/dashboard";
                        return (
                    <Dialog
                        title={tCommon.deletedTitle}
                        hideActions
                                closeDialog={() => navigate(redirectTo)}
                        footerContent={
                            <button
                                type="button"
                                className="btn bg-danger-subtle text-danger"
                                        onClick={() => navigate(redirectTo)}
                            >
                                {tCommon.close}
                            </button>
                        }
                    >
                        <div className="p-4 text-center">
                            <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success-subtle text-success mb-3" style={{ width: 52, height: 52 }}>
                                <i className="ti ti-check fs-4"></i>
                            </div>
                            <div className="fw-semibold fs-5 mb-1">{tCommon.deletedTitle}</div>
                            <div className="text-muted small">{tCommon.deletedBody}</div>
                        </div>
                            </Dialog>
                        );
                    })()
                )}

                    <div className="p-4">

                        <div
                            className="mb-4 p-3"
                            style={{
                                border: '1px solid #f5c2c7',
                                backgroundColor: '#f8d7da',
                                borderRadius: '8px',
                                color: '#842029',
                                display: 'flex',
                                alignItems: 'center',
                                fontWeight: 'bold',
                            }}
                        >
            <span
                style={{
                    fontSize: '1.5rem',
                    marginRight: '10px',
                }}
            >
                ❗
            </span>
                            <span>{deleteDialogData.alert}</span>
                        </div>

                        {/* Main Section */}
                        <div
                            className="p-3"
                            style={{
                                border: '1px solid #d1d1d1',
                                borderRadius: '8px',
                                backgroundColor: '#f8f9fa',
                            }}
                        >
                            <h4 style={{ marginBottom: '10px', color: '#495057' }}>
                                {deleteDialogData.title}
                            </h4>
                            <p
                                style={{
                                    marginBottom: '10px',
                                    color: '#6c757d',
                                    fontWeight: 'bold',
                                }}
                            >
                                {deleteDialogData.text}
                            </p>
                            <input
                                type="text"
                                placeholder={`Enter "${deleteDialogData.columnValue}" to confirm`}
                                value={deleteDialogData.userInput}
                                onChange={(e) =>
                                    setDeleteDialogData((prev) => ({
                                        ...prev,
                                        userInput: e.target.value,
                                    }))
                                }
                                className="form-control"
                                style={{
                                    border: '1px solid #ced4da',
                                    borderRadius: '5px',
                                    padding: '10px',
                                    width: '100%',
                                }}
                            />
                        </div>
                        <div>
                            {props.disable?.add?.disable && <AddContactButton addFunction={null} addTitle={"Delete"} disable={props.disable} style={{
                                float: "right",
                                marginTop: "20px",
                                marginBottom: "30px",
                            }} />}

                            {!props.disable?.add?.disable && <button
                                type="button"
                                className={`btn ${
                                    deleteDialogData.userInput === deleteDialogData.columnValue
                                        ? 'btn-primary text-white'
                                        : 'btn-secondary text-white'
                                } waves-effect`}
                                onClick={handleConfirmDelete}
                                disabled={deleteDialogData.userInput !== deleteDialogData.columnValue}
                                style={{
                                    float: "right",
                                    marginTop: "20px",
                                    marginBottom: "30px",
                                    cursor:
                                        deleteDialogData.userInput === deleteDialogData.columnValue
                                            ? 'pointer'
                                            : 'not-allowed',
                                }}
                            >
                                Delete
                            </button>}
                        </div>
                    </div>
            </>}
            {singleArgs && singleArgs.edit && JSON.stringify(singleArgs.details) != "[]" && <>
                {(() => {
                    const wrapperClass = props.singleFormWrapperClass || "flex gap-10 flex-column";
                    const innerClass = props.singleFormInnerClass || "form-group col-md-12";
                    const buttonsClass = props.singleFormButtonsClass || "";
                    const buttonStyle = props.singleFormButtonStyle || {
                        float: "right",
                        marginTop: "0px",
                        marginBottom: "0px",
                    };
                    return (
                        <div className={wrapperClass}>
                            <div className={innerClass}>
                                <div>
                                    {props.children}
                                </div>

                                <RenderFormFields
                                    fields={fieldsFormData}
                                    actionName={actionName}
                                    fieldsData={fieldsData ?? []}
                                    fieldsChange={fieldsChange}
                                    response={response}
                                    saveAction={saveCreateUserDialog}
                                />
                                <div className={buttonsClass}>
                                    <AddContactButton
                                        addFunction={saveCreateUserDialog}
                                        addTitle={"Save"}
                                        disable={props.disable}
                                        style={buttonStyle}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })()}
            </>}
            {singleArgs && singleArgs.edit && JSON.stringify(singleArgs.details) == "[]"&& <>
                <div className="flex gap-10 flex-column">
                    <div className="form-group col-md-12">
                        <div>
                            Data not loaded
                        </div>
                    </div>
                </div>
            </>}
            {singleArgs && singleArgs.create && <>
                <div>
                    {props.children}
                </div>

                <AddContactButton addFunction={addButtonHandler} addTitle={"Create"} disable={props.disable} style={{
                    width: "100%",
                    marginBottom: "30px",
                }} />

                {/*
                <button
                    type="button"
                    className={`btn btn-primary text-white waves-effect`}
                    onClick={addButtonHandler}
                    style={{
                        width: "100%",
                        marginBottom: "30px",
                    }}
                >
                    Create
                </button>*/}

                {dialog ? createPortal(
                    <Dialog title={props.addTitle}
                            editTitle={props.editTitle}
                            fieldsData={fieldsData}
                            closeDialog={closeCreateUserDialog}
                            saveDialog={saveCreateUserDialog} >

                        <div className="flex gap-10 flex-column">
                            <div className="form-group col-md-12">
                                <RenderFormFields fields={fieldsFormData} actionName={actionName} fieldsData={fieldsData} fieldsChange={fieldsChange} response={response} saveAction={saveCreateUserDialog}/>
                            </div>

                        </div>
                    </Dialog>, document.body) : null}
            </>}
        </>
    )
}

export default BasicCRUD
